import styled from 'styled-components';

export const Container = styled.div`
  font-family: 'IBM Plex Sans', sans-serif;
`;

export const Price = styled.span`
  display: inline-block;
  background-color: black;
  border-radius: 3px;
  font-size: 0.75rem;
  font-weight: 500;
  padding: 0 0.5rem;
  min-width: 76px;
  text-align: center;
`;

export const Quantity = styled.span`
  margin-left: 0.5rem;
`;

export const Description = styled.span`
  overflow-wrap: break-word;
`;

export const DescriptionContainer = styled.div`
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.125rem;
`;

export const PriceContainer = styled.div`
  margin-top: 0.13rem;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.3rem;
`;

export const Title = styled.div`
  font-size: 0.75rem;
  font-weight: 600;
  opacity: 0.7;
`;

export const PriceTitle = styled.span`
  opacity: 0.7;
  margin-right: 0.5rem;
`;
